module.exports = __webpack_public_path__ + "static/media/wood.42ae0642.jpg";